import React, { Component } from 'react';

const DARK = "#71532c"
class NavBlockTampa extends Component {
  render() {
    let widths = {
      box: this.props.screen.screenHeight * .48068669527896995708
    }
    let heights = {
      box: this.props.screen.screenHeight * .11587982832618025751
    }
    let sizes = {
      title: this.props.screen.screenHeight * .02199074074074074074,
      description: this.props.screen.screenHeight * .01388888888888888889
    }
    let margins = {
      descriptionTop: this.props.screen.screenHeight * .00651041666666666667
    }
    let horizontalRadius = this.props.screen.screenHeight * .00520833333333333333;
    let verticalRadius = this.props.screen.screenHeight * .00651041666666666667;

    return (
      <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <div style={{ width: widths.box, height: heights.box, borderRadius: this.props.screen.screenWidth * .02314814814814814815, backgroundColor: 'white', boxShadow: `${horizontalRadius}px ${verticalRadius}px ${verticalRadius}px 0px rgba(0,0,0,0.85)`   }}>
        {/* Icon */}
        <div style={{ position:"relative", width: widths.box * .25, height:"100%", float: "left", display:"flex", alignItems:"center", justifyContent:"center" }}>
          <img alt="Donor Stories" src={this.props.icon} style={{ height:"7.291666667vh" }} />
        </div>
        {/* Title & description */}
        <div style={{ position:"relative", width: widths.box * .60, height:"100%", float: "left", display:"table" }}>
          <div style={{ display:"table-cell", verticalAlign:"middle" }}>
            <div style={{ fontSize: sizes.title, float:"left", textAlign:"center", width:"100%", color: DARK }} className="crimson-semi-bold">
              <b>{this.props.title}</b>
            </div>
            <div className="opensans-regular" style={{ fontSize: sizes.description, float:"left", maxHeight: "6vh", overflow:"hidden", textAlign:"center", width:"100%", marginTop: margins.descriptionTop, display:"-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient:"vertical", color: DARK }}>
              {this.props.description}
            </div>
          </div>
        </div>
        {/* Arrow Icon */}
        <div style={{ position:"relative", width: widths.box * .15, height:"100%", float: "left", display:"flex", alignItems:"center", justifyContent:"center" }}>
          <img alt="Forward" src={this.props.arrow} style={{ height:"3vh" }} />
        </div>
        </div>
      </div>
    )
  }


}

export default NavBlockTampa;


// WEBPACK FOOTER //
// ./src/Components/Theme/Tampa/NavBlockTampa.jsx